import SegmentationOptionDirective from './SegmentationOptionDirective';
import './queryparams/module';
import './campaign/module';
import './branding/module';
import './abexperiment/module';
import './location/module';
import './demolandingpage/module';

export default angular.module('edge.platform.segmentation', ['edge.platform.segmentation.queryparams', 'edge.platform.segmentation.branding', 'edge.platform.segmentation.campaign', 'edge.platform.segmentation.abexperiment', 'edge.platform.segmentation.location', 'edge.platform.segmentation.demolandingpage']).directive('gwSegmentationOption', SegmentationOptionDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/module.js
// module id = 1074
// module chunks = 0